module.exports = __webpack_public_path__ + "img/radio-normal.b4d688c2.png";